export const colors = {
  primary: "#15b5b0",
  secondary: "#ff9e8b",
  tiercary: "#50b172",
  background: "#F5F4F5",
  text: "#101010",
  white: "#FFFFFF",
  error: "#FF4C4C",
  test1: "#ffe236",
  test2: "#6fabfa",
};
